import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  HealthCheckAnswersResponse,
  HealthCheckAnswersParams,
} from "models/bodyTemperature/healthCheckAnswers";
import { httpStatus } from "configs/httpStatus";
import { fetchHealthCheckAnswer } from "services/bodyTemperature";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./healthCheckAnswersActions";

function* healthCheckAnswersSaga({
  payload,
}: {
  payload: HealthCheckAnswersParams;
}) {
  try {
    const response: HealthCheckAnswersResponse = yield call(
      fetchHealthCheckAnswer,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || "error"));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetHealthCheckAnswersWatcher() {
  yield takeLatest(
    ActionType.HEALTH_CHECK_ANSWER as any,
    healthCheckAnswersSaga
  );
}

export default [fork(onGetHealthCheckAnswersWatcher)];
